var React = require('react');

function IconError (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.11764 1.40441C9.49411 0.69853 10.5059 0.698529 10.8824 1.40441L19.2157 17.0294C19.5709 17.6955 19.0883 18.5 18.3333 18.5H1.66666C0.911744 18.5 0.429055 17.6955 0.784311 17.0294L9.11764 1.40441ZM9.0625 7.25C9.0625 6.73223 9.48223 6.3125 10 6.3125C10.5178 6.3125 10.9375 6.73223 10.9375 7.25V10.375C10.9375 10.8928 10.5178 11.3125 10 11.3125C9.48223 11.3125 9.0625 10.8928 9.0625 10.375V7.25ZM11.25 14.75C11.25 15.4404 10.6904 16 10 16C9.30964 16 8.75 15.4404 8.75 14.75C8.75 14.0596 9.30964 13.5 10 13.5C10.6904 13.5 11.25 14.0596 11.25 14.75Z","fill":"currentColor"}));
}

IconError.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 19","fill":"currentColor"};

module.exports = IconError;

IconError.default = IconError;
